import { GAME_IDS } from "../core/types.js";
import { registerGame } from "../core/registry.js";
import FavoriteDancesSheet from "./components/Sheet.jsx";
import FavoriteDancesVoteCard from "./components/VoteCard.jsx";

export * from "./copy.js";
export * from "./api.js";
export { useFavoriteDancesSession } from "./hooks/useFavoriteDancesSession.js";
export { default as FavoriteDancesSheet } from "./components/Sheet.jsx";
export { default as FavoriteDancesVoteCard } from "./components/VoteCard.jsx";
export { default as CrewNudgeLine } from "./components/CrewNudgeLine.jsx";
export { default as CrewSignalFeedCard } from "./components/CrewSignalFeedCard.jsx";
export { default as FavoriteDancesHostKit } from "./components/host/HostKit.jsx";
export { default as HowItWorksPage } from "./pages/HowItWorksPage.jsx";
export { default as DemoVotePage } from "./demo/DemoVotePage.jsx";
export { canDemoVote } from "./demo/demoState.js";

registerGame({
  id: GAME_IDS.FAVORITE_DANCES,
  Sheet: FavoriteDancesSheet,
  VoteCard: FavoriteDancesVoteCard,
});
